@if (data.title) {
  <bv-dialog-title>{{ data.title }}</bv-dialog-title>
}
<bv-dialog-body class="py-6">
  <p class="text-base">{{ data.message }}</p>
</bv-dialog-body>
<bv-dialog-footer>
  <button bv-button variant="ghost" (click)="onCancel()">
    {{ data.cancelButton || "Cancel" }}
  </button>
  <button bv-button variant="primary" (click)="onConfirm()">
    {{ data.acceptButton || "Confirm" }}
  </button>
</bv-dialog-footer>
